(() => {
  function enhance(root = document) {
    root.querySelectorAll('.rc-article:not([data-editorial-ready])').forEach(article => {
      article.dataset.editorialReady = 'true';
      const body = article.querySelector('.rc-body');
      if (!body) return;
      const filmSlot = body.querySelector('.rc-film-slot');
      const film = article.querySelector(':scope > .rc-film');
      if (filmSlot && film) filmSlot.append(film);
      const toc = body.querySelector('nav');
      if (toc && toc.querySelector('a[href^="#"]')) {
        const layout = document.createElement('div');
        layout.className = 'rc-reading-layout';
        body.before(layout);
        const aside = document.createElement('aside');
        aside.className = 'rc-outline';
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = toc.querySelector('strong')?.textContent || toc.getAttribute('aria-label') || 'Contents';
        details.append(summary);
        const list = toc.querySelector('ol,ul');
        if (list) details.append(list);
        aside.append(details); layout.append(aside, body); toc.remove();
        const media = matchMedia('(min-width: 750px)');
        const setOpen = () => { details.open = media.matches; };
        setOpen(); media.addEventListener('change', setOpen);
        const links = [...aside.querySelectorAll('a[href^="#"]')];
        links.forEach(link => link.addEventListener('click', () => {
          if (!media.matches) details.open = false;
        }));
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            const current = entries.find(e => e.isIntersecting);
            if (!current) return;
            links.forEach(a => a.hash === '#' + current.target.id ? a.setAttribute('aria-current','location') : a.removeAttribute('aria-current'));
          }, {rootMargin:'-120px 0px -55% 0px'});
          body.querySelectorAll('h2[id]').forEach(h => observer.observe(h));
        }
      }
      body.querySelectorAll('table').forEach(table => {
        let wrapper = table.parentElement;
        if (wrapper === body || wrapper.tagName !== 'DIV') {
          wrapper = document.createElement('div'); table.before(wrapper); wrapper.append(table);
        }
        wrapper.classList.add('rc-table-scroll');
        const headers = [...table.querySelectorAll('thead th')];
        const rows = [...table.querySelectorAll('tbody tr')];
        if (headers.length && rows.length && !table.querySelector('[colspan],[rowspan]') && rows.every(r => r.cells.length === headers.length)) {
          table.classList.add('rc-stacked');
          rows.forEach(r => [...r.cells].forEach((cell,i) => cell.dataset.label = headers[i].textContent.trim()));
        } else { wrapper.tabIndex = 0; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance()); else enhance();
  document.addEventListener('shopify:section:load', e => enhance(e.target));
})();
